"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide3 = exports.HomepageSlide3 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const image_hover_reveal_1 = require("../main/image-hover-reveal");
class HomepageSlide3 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      @keyframes parallax-slide-from-west {
        from {
          opacity: 0;
          transform: translateX(200px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
      
      @keyframes parallax-slide-from-south {
        from {
          opacity: 0;
          transform: translateY(200px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      :host {
        display: block;
        background-color: #fafbf8;
        border-color: #e5e7eb;
        padding: 7rem 5rem;
        width: 100%;
        max-width: var(--slide-max-width);
        margin: auto;
        box-sizing: border-box;
        
        font-family: 'quaaykop-medium', sans-serif;
      }
      
      div.paragraph-1 {
        view-timeline-name: --paragraph-1-timeline;
        view-timeline-axis: block;
      }
      
      div.paragraph-1 div.title {
        font-size: 1.2rem;
        animation: parallax-slide-from-west linear;
        animation-timeline: --paragraph-1-timeline;
        animation-range: entry 0% entry 150%;
        animation-fill-mode: both;
      }

      div.paragraph-1 div.content {
        font-size: 2.7rem;
        margin: 1rem 0 2rem;
      }
      
      div.paragraph-1 div.content div:first-child {
        animation: parallax-slide-from-west linear;
        animation-timeline: --paragraph-1-timeline;
        animation-range: entry 20% entry 165%;
        animation-fill-mode: both;
      }
      
      div.paragraph-1 div.content div:last-child {
        animation: parallax-slide-from-west linear;
        animation-timeline: --paragraph-1-timeline;
        animation-range: entry 50% entry 180%;
        animation-fill-mode: both;
      }
      
      div.columns {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 2rem;
        
        view-timeline-name: --columns-timeline;
        view-timeline-axis: block;
      }
      
      div.columns div.column:first-child {
        animation: parallax-slide-from-south linear;
        animation-timeline: --columns-timeline;
        animation-range: entry 0% entry 90%;
        animation-fill-mode: both;
      }
      
      div.columns div.column:nth-child(2) {
        animation: parallax-slide-from-south linear;
        animation-timeline: --columns-timeline;
        animation-range: entry 20% entry 90%;
        animation-fill-mode: both;
      }
      
      div.columns div.column:last-child {
        animation: parallax-slide-from-south linear;
        animation-timeline: --columns-timeline;
        animation-range: entry 40% entry 90%;
        animation-fill-mode: both;
      }
      
      div.columns div.column div.title {
        padding: 1rem 0;
        font-size: 1.8rem;
        box-sizing: border-box;
      }
      
      div.columns div.column div.content {
        font-size: 1.1rem;
        line-height: 150%;
      }
      
      @media (max-width: 600px) {
        :host {
          padding: 2rem 1rem;
        }
        
        div.paragraph-1 {
          view-timeline-name: --paragraph-1-timeline;
          view-timeline-axis: block;
        }
  
        div.paragraph-1 div.content {
          font-size: 1.4rem;
        }
        
        div.columns {
            display: flex;
            flex-direction: column;
        }
        
        div.columns div.column:first-child {
          animation-timeline: view();
        }
        
        div.columns div.column:nth-child(2) {
          animation-timeline: view();
        }
        
        div.columns div.column:last-child {
          animation-timeline: view();
        }
        
        div.columns div.column div.title {
          padding: 1rem 0;
          font-size: 1.2rem;
          box-sizing: border-box;
        }
        
        div.columns div.column div.content {
          line-height: 180%;
        }
      }
    </style>
    <div class="paragraph-1">
      <div class="title beyond-stage">
        OUR PRODUCT
      </div>
      <div class="content">
        <div class="beyond-stage">FROM CAREFULLY SELECTED PREMIUM MATERIALS,</div>
        <div class="beyond-stage">AND PROVEN SAFETY TO TIMELESS BEAUTY COME TOGETHER.</div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <image-hover-reveal front-src="/files/assets/images/slide-3-column-1-front.jpg" back-src="/files/assets/images/slide-3-column-1-back.jpg" style="width: 100%; aspect-ratio: 4 / 3;"></image-hover-reveal>
        <div class="title">
          SOURCES FROM THE FINEST
        </div>
        <div class="content">
          Aileen is crafted using only top-grade raw materials imported from the US ensuring purity, consistency, and quality you can trust
        </div>
      </div>
      <div class="column">
        <image-hover-reveal front-src="/files/assets/images/slide-3-column-2-front.jpg" back-src="/files/assets/images/slide-3-column-2-back.jpg" style="width: 100%; aspect-ratio: 4 / 3;"></image-hover-reveal>
        <div class="title">
          TIMELESS BEAUTY & STRUCTURE
        </div>
        <div class="content">
          Beauty That Lasts, Strength You Can Feel Designed to enhance natural beauty while maintaining structural integrity, Aileen deliver refined aesthetics with lasting stability and balance
        </div>
      </div>
      <div class="column">
        <image-hover-reveal front-src="/files/assets/images/slide-3-column-3-front.jpg" back-src="/files/assets/images/slide-3-column-3-back.jpg" style="width: 100%; aspect-ratio: 4 / 3;"></image-hover-reveal>
        <div class="title">
          PROVEN SAFETY
        </div>
        <div class="content">
          Develops under rigorous standards and trict quality control, Aileen prioritizes safety at every step - because confidence begins with trust
        </div>
      </div>
    </div>`;
    }
}
exports.HomepageSlide3 = HomepageSlide3;
const defineHomepageSlide3 = (name) => {
    (0, image_hover_reveal_1.defineImageHoverReveal)('image-hover-reveal');
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide3);
};
exports.defineHomepageSlide3 = defineHomepageSlide3;
